import { PageHeader } from "@/components/PageHeader";
import { AgentsSection } from "@/components/AgentsSection";

// Agents lists agent definitions (embedded defaults + user overrides) and lets
// the user edit, validate, save, and reset their YAML per SPEC §4.1.
export default function Agents() {
  return (
    <>
      <PageHeader
        title="Agents"
        description="Declarative agent definitions — edit YAML, validate, and reset to defaults."
      />
      <div className="mt-4">
        <AgentsSection />
      </div>
    </>
  );
}
